const styles = {
  cardBg: {
    p: 3,
    background:
      "linear-gradient(57.59deg, #151F16 -1.58%, #004537 98.35%), linear-gradient(180deg, rgba(236, 234, 229, 0) 0%, #ECEAE5 100%), #FFFFFF;",
    borderRadius: 4,
  },
  chip: {
    mb: 2,
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: "white",
    px: 2,
    py: 1,
    borderRadius: 4,
    width: "max-content",
  },
  upgradeButton: {
    borderRadius: 2,
    py: 1,
    color: "white",
    borderColor: "white",
    "&:hover": {
      color: "yellow.main",
      borderColor: "yellow.main",
    },
  },
};

export default styles;
